/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { DocumentsListPage } from './DocumentsListPage'
import { DOCUMENTS_VIEW_TYPE } from './types'

export const SystemDocumentsPage: React.FC = () => {
  return <DocumentsListPage key="systemDocuments" viewType={DOCUMENTS_VIEW_TYPE.systemDocuments} />
}
